import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { publishRecords } from "@/api/chatbot/chatbot";
export default {
  name: "publishList",
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      kindList: [{
        label: '全部',
        value: ''
      }, {
        label: 'semantic_entry',
        value: 'semantic_entry'
      }, {
        label: 'semantic_import',
        value: 'semantic_import'
      }, {
        label: 'analysis_pattern',
        value: 'analysis_pattern'
      }],
      searchData: {
        page: 1,
        limit: 80,
        operation: '',
        resource_id: '',
        kind: '',
        actor: '',
        q: '',
        resource_type: ''
      },
      tableData: [],
      allTableData: []
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (e == 1) {
        this.searchData.page = 1;
      }

      this.reqLoading = true;
      publishRecords(this.searchData).then(function (res) {
        var items = res.items || []; // 2. 循环加工映射数据

        var processedItems = items.map(function (item) {
          var before = item.before || {};
          var after = item.after || {}; // --- 算法段 A：处理拓扑关系路径 ---

          var topologyPath = [item.data_source_id, item.kind].filter(Boolean).join(' / ');
          var beforeEnabled = before.enabled === undefined ? '' : 'before enabled=' + before.enabled;
          var afterEnabled = after.enabled === undefined ? '' : 'after enabled=' + after.enabled;
          var title = after.title || before.title || after.pattern_key || before.pattern_key || after.file_name || '';
          var beforeVersion = before.version || '';
          var afterVersion = after.version || '';
          var summaryParts = [title, beforeVersion || afterVersion ? 'version ' + [beforeVersion, afterVersion].filter(Boolean).join(' -> ') : '', [beforeEnabled, afterEnabled].filter(Boolean).join(' / '), after.entry_count === undefined ? '' : 'entries ' + after.entry_count].filter(Boolean);
          var jsonDump = '';

          try {
            jsonDump = JSON.stringify({
              before: before,
              after: after,
              metadata: item.metadata || {}
            }, null, 2);
          } catch (e) {
            jsonDump = 'JSON 序列化失败';
          }

          var targetEntryId = after.entry_id || before.entry_id || (item.resource_type === 'semantic_entry' ? item.resource_id : '');
          return _objectSpread(_objectSpread({}, item), {}, {
            _topologyPath: topologyPath,
            _summaryParts: summaryParts,
            _jsonDump: jsonDump,
            _targetEntryId: targetEntryId
          });
        });
        _this.allTableData = processedItems;

        _this.renderCurrentPageData(); // 分页断言：如果返回的条数等于期望的 limit 条数，说明潜在还有下一页

      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    renderCurrentPageData: function renderCurrentPageData() {
      var start = (this.searchData.page - 1) * this.searchData.limit;
      var end = start + this.searchData.limit;
      this.tableData = this.allTableData.slice(start, end);
      this.hasMore = this.allTableData.length > end;
    },
    changePage: function changePage(targetPage) {
      if (targetPage < 1) return;
      this.searchData.page = targetPage;
      this.renderCurrentPageData();
    },
    // 切换单页条数事件
    sizeChange: function sizeChange(val) {
      this.searchData.limit = val;
      this.searchData.page = 1;
      this.renderCurrentPageData();
    }
  }
};